<template>
  <div class="f360-tabs">
    <el-tabs v-model="activeTab" class="tab__tabs" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="tab in tabs"
        :key="tab.name"
        :name="tab.name"
        :disabled="tab.disabled"
      >
        <template #label>
          <span class="tab__tab">
            <div class="tab__label">{{ tab.label }}</div>
            <F360Bagde
              class="bagde"
              v-if="tab.quantidade"
              :text="tab.quantidade.toString()"
              shape="circle"
              typeColor="danger"
            />
          </span>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup lang="ts">
interface IProps {
  tabs: {
    name: string;
    label: string;
    quantidade?: number;
    disabled?: boolean;
  }[];
  defineTab?: unknown;
}
import { ref } from 'vue'
import F360Bagde from '@/ui/components/Bagdes/Bagde/F360Bagde.vue'
import { TabsPaneContext } from 'element-plus'
const props = defineProps<IProps>();
const activeTab = ref<string>(
  (props.defineTab as string) || props.tabs[0].name
);
const emit = defineEmits<{
  (e: "tab-click", tab: string): void;
}>();
defineExpose({
  activeTab
});
const handleTabClick = (pane: TabsPaneContext) => {
  emit("tab-click", pane.props.name as string);
};
</script>

<style lang="scss" scoped>
@use "sass:map" as *;
@use "@/ui/styles/theme/f360-theme.scss" as *;

.f360-tabs {
  width: 100%;
  background: _map.get($map: $neutro2, $key: 50);
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  @include border-radius();

  $financas-tabs: ".financas-tabs";

  &:deep(#{$financas-tabs}__header) {
    margin-bottom: 0;
    background: _map.get($map: $neutro2, $key: 50);
    padding: 0;
    @include border-radius();
  }

  &:deep(.is-active) {
    color: _map.get($map: $azulPrincipal, $key: 700);
  }

  .tab {
    &__tabs {
      position: relative;
      width: 100%;

      &:deep(#{$financas-tabs}__nav-wrap) {
        &::after {
          display: none;
        }
      }

      &:deep(#{$financas-tabs}__nav) {
        z-index: auto;
        padding: 0 1rem 0 0;
      }

      &:deep(#{$financas-tabs}__nav-item) {
        height: 2.25rem;
        color: _map.get($map: $neutro, $key: 950);
      }
    }

    &__tab {
      @include font-schema(0.875rem, 700, 1rem);
      position: relative;
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 0 0.5rem;

      .bagde {
        margin-left: 0.5rem;
      }
    }
  }
}
</style>
